export default __webpack_public_path__ + "static/media/slide4.b8b04013.png";